export const sessions = {
  'student-session-ball': {
    room: 'ball',
    groups: ['student'],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '8:00am-5:00pm',
    name: 'Student Session',
    id: 'student-session-ball',
  },
  'welcome-reception-hotel': {
    room: 'hotel',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '5:30pm-7:30pm',
    name: 'Welcome Reception',
    id: 'welcome-reception-hotel',
  },
  'monday-plenary-session-1-ball': {
    room: 'ball',
    groups: ['plenary'],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '8:00am-9:30am',
    name: 'Monday Plenary Session 1',
    plenId: 'monjoint1',
    id: 'monday-plenary-session-1-ball',
  },
  'monday-plenary-session-2-ball': {
    room: 'ball',
    groups: ['plenary'],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '10:00am-12:00pm',
    name: 'Monday Plenary Session 2',
    plenId: 'monjoint2',
    id: 'monday-plenary-session-2-ball',
  },
  'monday-lunch-ballJr': {
    room: 'ballJr',
    groups: [],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '12:00pm - 1:30pm',
    name: 'Monday Lunch',
    topicS: 'GEMMEE Mentoring Lunch',
    topicL: 'GEMMEE Mentoring Lunch',
    id: 'monday-lunch-ballJr',
  },
  'monday-breakout-1-ballA': {
    room: 'ballA',
    groups: ['KiTS', 'RX', 'MESO', 'CEDAR'],
    isJoint: true,
    date: 'Monday, June 23',
    day: 'monday',
    time: '1:30pm-3:30pm',
    name: 'Monday Breakout 1',
    topicS: 'Substorm onset Part 1',
    topicL: 'Substorm onset Part 1',
    id: 'monday-breakout-1-ballA',
  },
  'monday-breakout-1-ballB': {
    room: 'ballB',
    groups: ['COMP', 'CEDAR'],
    isJoint: true,
    date: 'Monday, June 23',
    day: 'monday',
    time: '1:30pm-3:30pm',
    name: 'Monday Breakout 1',
    topicS: 'Comparative Ionospheres',
    topicL: 'Comparative Ionospheres',
    id: 'monday-breakout-1-ballB',
  },
  'monday-breakout-1-307': {
    room: '307',
    groups: ['MPEC'],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '1:30pm-3:30pm',
    name: 'Monday Breakout 1',
    topicS:
      'Advances in understanding precipitation sources and effects in the coupled MIT system',
    topicL:
      'Advances in understanding precipitation sources and effects in the coupled MIT system',
    id: 'monday-breakout-1-307',
  },
  'monday-breakout-1-308': {
    room: '308',
    groups: ['CP'],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '1:30pm-3:30pm',
    name: 'Monday Breakout 1',
    topicS: 'Summary of GEM Cold Plasma Focus Group activities',
    topicL: 'Summary of GEM Cold Plasma Focus Group activities',
    id: 'monday-breakout-1-308',
  },
  'monday-breakout-1-309': {
    room: '309',
    groups: ['MDT'],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '1:30pm-3:30pm',
    name: 'Monday Breakout 1',
    topicS:
      'Identifying Knowledge Gaps in Dayside Transient Processes Research',
    topicL:
      'Identifying Knowledge Gaps in Dayside Transient Processes Research',
    id: 'monday-breakout-1-309',
  },
  'monday-breakout-1-318': {
    room: '318',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '1:30pm-3:30pm',
    name: 'Monday Breakout 1',
    topicS:
      "Advancing our understanding of Ionospheric-Thermospheric Dynamics: Ground- and Space-Based Observations During Solar Cycle 25's Ascending Phase",
    topicL:
      "Advancing our understanding of Ionospheric-Thermospheric Dynamics: Ground- and Space-Based Observations During Solar Cycle 25's Ascending Phase",
    id: 'monday-breakout-1-318',
  },
  'monday-breakout-1-319': {
    room: '319',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '1:30pm-3:30pm',
    name: 'Monday Breakout 1',
    topicS:
      'The Science of Ionospheres, Thermospheres and Mesospheres in the Next Decade',
    topicL:
      'The Science of Ionospheres, Thermospheres and Mesospheres in the Next Decade',
    id: 'monday-breakout-1-319',
  },
  'monday-breakout-2-ballA': {
    room: 'ballA',
    groups: ['KiTS', 'RX', 'MESO', 'CEDAR'],
    isJoint: true,
    date: 'Monday, June 23',
    day: 'monday',
    time: '4:00pm-6:00pm',
    name: 'Monday Breakout 2',
    topicS: 'Substorm onset Part 2',
    topicL: 'Substorm onset Part 2',
    id: 'monday-breakout-2-ballA',
  },
  'monday-breakout-2-ballB': {
    room: 'ballB',
    groups: ['MMV', 'CEDAR'],
    isJoint: true,
    date: 'Monday, June 23',
    day: 'monday',
    time: '4:00pm-6:00pm',
    name: 'Monday Breakout 2',
    topicS: 'Snakes on a Spaceship: The Menagerie',
    topicL: 'Snakes on a Spaceship: The Menagerie',
    id: 'monday-breakout-2-ballB',
  },
  'monday-breakout-2-307': {
    room: '307',
    groups: ['MPEC'],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '4:00pm-6:00pm',
    name: 'Monday Breakout 2',
    topicS:
      'Discussion of the goals and next steps for the MPEC Focus Group with the community',
    topicL:
      'Discussion of the goals and next steps for the MPEC Focus Group with the community',
    id: 'monday-breakout-2-307',
  },
  'monday-breakout-2-308': {
    room: '308',
    groups: ['CP'],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '4:00pm-6:00pm',
    name: 'Monday Breakout 2',
    topicS: 'Future Plans of Cold Plasma Focus Group Community',
    topicL: 'Future Plans of Cold Plasma Focus Group Community',
    id: 'monday-breakout-2-308',
  },
  'monday-breakout-2-309': {
    room: '309',
    groups: ['MDT'],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '4:00pm-6:00pm',
    name: 'Monday Breakout 2',
    topicS:
      'Multiscale Dayside Transients: Community Research and Interactive Discussions',
    topicL:
      'Multiscale Dayside Transients: Community Research and Interactive Discussions',
    id: 'monday-breakout-2-309',
  },
  'monday-breakout-2-318': {
    room: '318',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '4:00pm-6:00pm',
    name: 'Monday Breakout 2',
    topicS:
      'Traveling Ionospheric Disturbances (TIDs): Generation Mechanisms and Impacts on the IT system',
    topicL:
      'Traveling Ionospheric Disturbances (TIDs): Generation Mechanisms and Impacts on the IT system',
    id: 'monday-breakout-2-318',
  },
  'monday-breakout-2-319': {
    room: '319',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '4:00pm-6:00pm',
    name: 'Monday Breakout 2',
    topicS: 'How does GDC Science address the new decadal survey?',
    topicL: 'How does GDC Science address the new decadal survey?',
    id: 'monday-breakout-2-319',
  },
  'monday-dinner-ballJr': {
    room: 'ballJr',
    groups: [],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '6:00pm-8:30pm',
    name: 'Monday Dinner',
    topicS: 'Career Panel Dinner for Students',
    topicL: 'Career Panel Dinner for Students',
    id: 'monday-dinner-ballJr',
  },
  'monday-dinner-boardroom': {
    room: 'boardroom',
    groups: [],
    isJoint: false,
    date: 'Monday, June 23',
    day: 'monday',
    time: '6:00pm-8:30pm',
    name: 'Monday Dinner',
    topicS: 'CEDAR CSSC dinner',
    topicL: 'CEDAR CSSC dinner',
    id: 'monday-dinner-boardroom',
  },
  'tuesday-plenary-sessions-ballB': {
    room: 'ballB',
    groups: ['plenary'],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '8:00am-9:30am',
    name: 'Tuesday Plenary Sessions',
    plenId: 'tueGEM',
    id: 'tuesday-plenary-sessions-ballB',
  },
  'tuesday-plenary-sessions-ballA': {
    room: 'ballA',
    groups: ['plenary'],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '8:00am-9:30am',
    name: 'Tuesday Plenary Sessions',
    plenId: 'tueCEDAR',
    id: 'tuesday-plenary-sessions-ballA',
  },
  'tuesday-breakout-1-ballA': {
    room: 'ballA',
    groups: ['MESO', 'MPEC', 'CEDAR'],
    isJoint: true,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '10:00am-12:00pm',
    name: 'Tuesday Breakout 1',
    topicS:
      'New opportunities for addressing outstanding problems in magnetosphere-ionosphere-thermosphere physics using sounding rockets launched from Alaska',
    topicL:
      'New opportunities for addressing outstanding problems in magnetosphere-ionosphere-thermosphere physics using sounding rockets launched from Alaska',
    id: 'tuesday-breakout-1-ballA',
  },
  'tuesday-breakout-1-ballB': {
    room: 'ballB',
    groups: ['RBSoS', 'CEDAR'],
    isJoint: true,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '10:00am-12:00pm',
    name: 'Tuesday Breakout 1',
    topicS:
      'Effects of radiation belt particle precipitation on the atmosphere',
    topicL:
      'Effects of radiation belt particle precipitation on the atmosphere',
    id: 'tuesday-breakout-1-ballB',
  },
  'tuesday-breakout-1-307': {
    room: '307',
    groups: ['GIC'],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '10:00am-12:00pm',
    name: 'Tuesday Breakout 1',
    topicS: 'Future FG Ideas and Current FG Efforts',
    topicL: 'Future FG Ideas and Current FG Efforts',
    id: 'tuesday-breakout-1-307',
  },
  'tuesday-breakout-1-308': {
    room: '308',
    groups: ['CP'],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '10:00am-12:00pm',
    name: 'Tuesday Breakout 1',
    topicS:
      'Recent Progress of the Cold Plasma Community Across all Relevant Topics',
    topicL:
      'Recent Progress of the Cold Plasma Community Across all Relevant Topics',
    id: 'tuesday-breakout-1-308',
  },
  'tuesday-breakout-1-309': {
    room: '309',
    groups: ['MDT', 'RX'],
    isJoint: true,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '10:00am-12:00pm',
    name: 'Tuesday Breakout 1',
    topicS:
      'Exploring Dayside Dynamics: Transient Processes Driving Magnetic Reconnection Across the Magnetosphere',
    topicL:
      'Exploring Dayside Dynamics: Transient Processes Driving Magnetic Reconnection Across the Magnetosphere',
    id: 'tuesday-breakout-1-309',
  },
  'tuesday-breakout-1-318': {
    room: '318',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '10:00am-12:00pm',
    name: 'Tuesday Breakout 1',
    topicS: 'Predictability of the geospace environment',
    topicL: 'Predictability of the geospace environment',
    id: 'tuesday-breakout-1-318',
  },
  'tuesday-breakout-1-319': {
    room: '319',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '10:00am-12:00pm',
    name: 'Tuesday Breakout 1',
    topicS: 'Impacts of Natural and Artificial Hazards on the Upper Atmosphere',
    topicL: 'Impacts of Natural and Artificial Hazards on the Upper Atmosphere',
    id: 'tuesday-breakout-1-319',
  },
  'tuesday-lunch-304': {
    room: '304',
    groups: [],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '12:00pm-1:30pm',
    name: 'Tuesday Lunch',
    topicS: 'GEM - Student Lunch + Rep Candidate Presentations',
    topicL: 'GEM - Student Lunch + Rep Candidate Presentations',
    id: 'tuesday-lunch-304',
  },
  'tuesday-lunch-boardroom': {
    room: 'boardroom',
    groups: [],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '12:00pm-1:30pm',
    name: 'Tuesday Lunch',
    topicS: "CEDAR - Judge's lunch",
    topicL: "CEDAR - Judge's lunch",
    id: 'tuesday-lunch-boardroom',
  },
  'tuesday-breakout-2-ballA': {
    room: 'ballA',
    groups: ['MESO', 'CEDAR'],
    isJoint: true,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '1:30pm-3:30pm',
    name: 'Tuesday Breakout 2',
    topicS:
      'Continuum Emissions Across Geospace: From the subauroral region to the aurora and dayside',
    topicL:
      'Continuum Emissions Across Geospace: From the subauroral region to the aurora and dayside',
    id: 'tuesday-breakout-2-ballA',
  },
  'tuesday-breakout-2-ballB': {
    room: 'ballB',
    groups: ['MPEC', 'CEDAR'],
    isJoint: true,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '1:30pm-3:30pm',
    name: 'Tuesday Breakout 2',
    topicS:
      'Unraveling the global ionospheric current circuits and their role and impact in the M-I-T system',
    topicL:
      'Unraveling the global ionospheric current circuits and their role and impact in the M-I-T system',
    id: 'tuesday-breakout-2-ballB',
  },
  'tuesday-breakout-2-308': {
    room: '308',
    groups: ['COMP'],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '1:30pm-3:30pm',
    name: 'Tuesday Breakout 2',
    topicS: 'Planetary space physics data open house',
    topicL: 'Planetary space physics data open house',
    id: 'tuesday-breakout-2-308',
  },
  'tuesday-breakout-2-309': {
    room: '309',
    groups: ['RBSoS', 'CP'],
    isJoint: true,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '1:30pm-3:30pm',
    name: 'Tuesday Breakout 2',
    topicS: 'Coupling between the radiation belts and the plasmasphere',
    topicL: 'Coupling between the radiation belts and the plasmasphere',
    id: 'tuesday-breakout-2-309',
  },
  'tuesday-breakout-2-318': {
    room: '318',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '1:30pm-3:30pm',
    name: 'Tuesday Breakout 2',
    topicS:
      'Long-term variation in the ionosphere-thermosphere-mesosphere (ITM) system',
    topicL:
      'Long-term variation in the ionosphere-thermosphere-mesosphere (ITM) system',
    id: 'tuesday-breakout-2-318',
  },
  'tuesday-breakout-2-319': {
    room: '319',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '1:30pm-3:30pm',
    name: 'Tuesday Breakout 2',
    topicS:
      '(GC) Redefining Polar Cap Patches: Understanding High-Latitude Irregularities, and their implications for the coupled MIT system - 1',
    topicL:
      '(GC) Redefining Polar Cap Patches: Understanding High-Latitude Irregularities, and their implications for the coupled MIT system - 1',
    id: 'tuesday-breakout-2-319',
  },
  'tuesday-poster-session-posters': {
    room: 'posters',
    groups: [],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '3:30pm-6:30pm',
    name: 'Tuesday Poster Session',
    id: 'tuesday-poster-session-posters',
  },
  'evening-activities-boardroom': {
    room: 'boardroom',
    groups: [],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '6:30pm-8:30pm',
    name: 'Evening Activities',
    topicS: "CEDAR - Poster judge's dinner",
    topicL: "CEDAR - Poster judge's dinner",
    id: 'evening-activities-boardroom',
  },
  'evening-activities-away': {
    room: 'away',
    groups: [],
    isJoint: false,
    date: 'Tuesday, June 24',
    day: 'tuesday',
    time: '6:40-late',
    name: 'Evening Activities',
    topicS: 'Excursion - Iowa Cubs baseball game',
    topicL: 'Excursion - Iowa Cubs baseball game',
    id: 'evening-activities-away',
  },
  'wednesday-plenary-session-ball': {
    room: 'ball',
    groups: ['plenary'],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '8:00am-9:30am',
    name: 'Wednesday Plenary Session',
    plenId: 'wed',
    id: 'wednesday-plenary-session-ball',
  },
  'wednesday-breakout-1-ballA': {
    room: 'ballA',
    groups: ['MESO', 'CEDAR'],
    isJoint: true,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '10:00am-12:00pm',
    name: 'Wednesday Breakout 1',
    topicS:
      'Building a Long-Term Strategy for Ground-Based Instrumentation in Heliophysics',
    topicL:
      'Building a Long-Term Strategy for Ground-Based Instrumentation in Heliophysics',
    id: 'wednesday-breakout-1-ballA',
  },
  'wednesday-breakout-1-ballB': {
    room: 'ballB',
    groups: ['MPEC', 'CEDAR'],
    isJoint: true,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '10:00am-12:00pm',
    name: 'Wednesday Breakout 1',
    topicS:
      'Whole-Atmosphere Coupling and Its Impact on the Magnetosphere-Ionosphere-Thermosphere System: New Perspectives from Observations and Modeling',
    topicL:
      'Whole-Atmosphere Coupling and Its Impact on the Magnetosphere-Ionosphere-Thermosphere System: New Perspectives from Observations and Modeling',
    id: 'wednesday-breakout-1-ballB',
  },
  'wednesday-breakout-1-307': {
    room: '307',
    groups: ['GIC'],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '10:00am-12:00pm',
    name: 'Wednesday Breakout 1',
    topicS: 'Ground Magnetic Field Perturbation Modelling Challenge Session',
    topicL: 'Ground Magnetic Field Perturbation Modelling Challenge Session',
    id: 'wednesday-breakout-1-307',
  },
  'wednesday-breakout-1-308': {
    room: '308',
    groups: ['RBSoS'],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '10:00am-12:00pm',
    name: 'Wednesday Breakout 1',
    topicS: 'Radiation Belts as a System of Systems: General Session',
    topicL: 'Radiation Belts as a System of Systems: General Session',
    id: 'wednesday-breakout-1-308',
  },
  'wednesday-breakout-1-309': {
    room: '309',
    groups: ['MLGEM', 'CEDAR'],
    isJoint: true,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '10:00am-12:00pm',
    name: 'Wednesday Breakout 1',
    topicS:
      'Machine Learning for Geospace and Atmospheric Environment Modeling - General Contribution',
    topicL:
      'Machine Learning for Geospace and Atmospheric Environment Modeling - General Contribution',
    id: 'wednesday-breakout-1-309',
  },
  'wednesday-breakout-1-318': {
    room: '318',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '10:00am-12:00pm',
    name: 'Wednesday Breakout 1',
    topicS: 'Multi-decadal Variation',
    topicL: 'Multi-decadal Variation',
    id: 'wednesday-breakout-1-318',
  },
  'wednesday-breakout-1-319': {
    room: '319',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '10:00am-12:00pm',
    name: 'Wednesday Breakout 1',
    topicS:
      '(GC) Redefining Polar Cap Patches: Understanding High-Latitude Irregularities, and their implications for the coupled MIT system - 2',
    topicL:
      '(GC) Redefining Polar Cap Patches: Understanding High-Latitude Irregularities, and their implications for the coupled MIT system - 2',
    id: 'wednesday-breakout-1-319',
  },
  'wednesday-lunch-ballA': {
    room: 'ballA',
    groups: [],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '12:00pm-1:30pm',
    name: 'Wednesday Lunch',
    topicS: 'Agency office hours',
    topicL: 'Agency office hours',
    id: 'wednesday-lunch-ballA',
  },
  'wednesday-lunch-boardroom': {
    room: 'boardroom',
    groups: [],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '12:00pm-1:30pm',
    name: 'Wednesday Lunch',
    topicS: "CEDAR - Judge's Lunch",
    topicL: "CEDAR - Judge's Lunch",
    id: 'wednesday-lunch-boardroom',
  },
  'wednesday-breakout-2-ballA': {
    room: 'ballA',
    groups: ['MESO', 'CEDAR'],
    isJoint: true,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '1:30pm-3:30pm',
    name: 'Wednesday Breakout 2',
    topicS: 'Multi-scale Dynamics in the M-I-T System',
    topicL: 'Multi-scale Dynamics in the M-I-T System',
    id: 'wednesday-breakout-2-ballA',
  },
  'wednesday-breakout-2-ballB': {
    room: 'ballB',
    groups: ['MPEC', 'CEDAR'],
    isJoint: true,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '1:30pm-3:30pm',
    name: 'Wednesday Breakout 2',
    topicS:
      'Ionosphere-Thermosphere (IT) response and feedback to the drivers in the magnetosphere (M)',
    topicL:
      'Ionosphere-Thermosphere (IT) response and feedback to the drivers in the magnetosphere (M)',
    id: 'wednesday-breakout-2-ballB',
  },
  'wednesday-breakout-2-307': {
    room: '307',
    groups: ['RX'],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '1:30pm-3:30pm',
    name: 'Wednesday Breakout 2',
    topicS:
      'Toward a better understanding of the fundamental physics in magnetic reconnection: energy conversion mechanisms and reconnection-turbulence interaction',
    topicL:
      'Toward a better understanding of the fundamental physics in magnetic reconnection: energy conversion mechanisms and reconnection-turbulence interaction',
    id: 'wednesday-breakout-2-307',
  },
  'wednesday-breakout-2-308': {
    room: '308',
    groups: ['RBSoS'],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '1:30pm-3:30pm',
    name: 'Wednesday Breakout 2',
    topicS: 'Radiation Belts as a System of Systems: Magnetotail Coupling',
    topicL: 'Radiation Belts as a System of Systems: Magnetotail Coupling',
    id: 'wednesday-breakout-2-308',
  },
  'wednesday-breakout-2-309': {
    room: '309',
    groups: ['MLGEM', 'CEDAR'],
    isJoint: true,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '1:30pm-3:30pm',
    name: 'Wednesday Breakout 2',
    topicS:
      'Machine Learning for Geospace and Atmospheric Environment Modeling: Storm Challenge',
    topicL:
      'Machine Learning for Geospace and Atmospheric Environment Modeling: Storm Challenge',
    id: 'wednesday-breakout-2-309',
  },
  'wednesday-breakout-2-318': {
    room: '318',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '1:30pm-3:30pm',
    name: 'Wednesday Breakout 2',
    topicS:
      'A Tutorial on the NSF NCAR Whole Atmosphere Community Climate Model with Thermosphere/Ionosphere Extension (WACCM-X)',
    topicL:
      'A Tutorial on the NSF NCAR Whole Atmosphere Community Climate Model with Thermosphere/Ionosphere Extension (WACCM-X)',
    id: 'wednesday-breakout-2-318',
  },
  'wednesday-breakout-2-319': {
    room: '319',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '1:30pm-3:30pm',
    name: 'Wednesday Breakout 2',
    topicS: 'Equatorial Aeronomy in Data Sparse Regions',
    topicL: 'Equatorial Aeronomy in Data Sparse Regions',
    id: 'wednesday-breakout-2-319',
  },
  'wednesday-poster-session-posters': {
    room: 'posters',
    groups: [],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '3:30pm-5:30pm',
    name: 'Wednesday Poster Session',
    id: 'wednesday-poster-session-posters',
  },
  'wednesday-dinner-boardroom': {
    room: 'boardroom',
    groups: [],
    isJoint: false,
    date: 'Wednesday, June 25',
    day: 'wednesday',
    time: '5:30pm-8:30pm',
    name: 'Wednesday Dinner',
    topicS: "CEDAR - Poster Judge's Dinner",
    topicL: "CEDAR - Poster Judge's Dinner",
    id: 'wednesday-dinner-boardroom',
  },
  'thursday-plenary-sessions-ballB': {
    room: 'ballB',
    groups: ['plenary'],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '8:00am-9:30am',
    name: 'Thursday Plenary Sessions',
    plenId: 'thuGEM',
    id: 'thursday-plenary-sessions-ballB',
  },
  'thursday-plenary-sessions-ballA': {
    room: 'ballA',
    groups: ['plenary'],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '8:00am-9:30am',
    name: 'Thursday Plenary Sessions',
    plenId: 'thuCEDAR',
    id: 'thursday-plenary-sessions-ballA',
  },
  'community-care---compassionate-leadership-for-burnout-305': {
    room: '305',
    groups: ['burnout'],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '10:00am-11:00am',
    name: 'Community Care - Compassionate leadership for burnout',
    id: 'community-care---compassionate-leadership-for-burnout-305',
  },
  'thursday-breakout-1-ballA': {
    room: 'ballA',
    groups: ['MESO', 'MMV', 'SCIMM', 'CEDAR'],
    isJoint: true,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '10:00am-12:00pm',
    name: 'Thursday Breakout 1',
    topicS:
      'Making discoveries with the Multiscale Atmosphere Geospace Environment (MAGE) Model',
    topicL:
      'Making discoveries with the Multiscale Atmosphere Geospace Environment (MAGE) Model',
    id: 'thursday-breakout-1-ballA',
  },
  'thursday-breakout-1-ballB': {
    room: 'ballB',
    groups: ['MPEC', 'CEDAR'],
    isJoint: true,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '10:00am-12:00pm',
    name: 'Thursday Breakout 1',
    topicS:
      'High-latitude Thermosphere Dynamics and Their Impacts on the Magnetosphere-Ionosphere-Thermosphere System During Geomagnetically Active Periods',
    topicL:
      'High-latitude Thermosphere Dynamics and Their Impacts on the Magnetosphere-Ionosphere-Thermosphere System During Geomagnetically Active Periods',
    id: 'thursday-breakout-1-ballB',
  },
  'thursday-breakout-1-307': {
    room: '307',
    groups: ['RX'],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '10:00am-12:00pm',
    name: 'Thursday Breakout 1',
    topicS:
      'Beyond semantics: when is reconnection \u201celectron-only\u201d in observations and simulations?',
    topicL:
      'Beyond semantics: when is reconnection \u201celectron-only\u201d in observations and simulations?',
    id: 'thursday-breakout-1-307',
  },
  'thursday-breakout-1-308': {
    room: '308',
    groups: ['RBSoS'],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '10:00am-12:00pm',
    name: 'Thursday Breakout 1',
    topicS: 'The future of radiation belt system science',
    topicL: 'The future of radiation belt system science',
    id: 'thursday-breakout-1-308',
  },
  'thursday-breakout-1-309': {
    room: '309',
    groups: ['GIC', 'GMAG'],
    isJoint: true,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '10:00am-12:00pm',
    name: 'Thursday Breakout 1',
    topicS: 'GMAG Update and GIC General Contribution Session',
    topicL: 'GMAG Update and GIC General Contribution Session',
    id: 'thursday-breakout-1-309',
  },
  'thursday-breakout-1-318': {
    room: '318',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '10:00am-12:00pm',
    name: 'Thursday Breakout 1',
    topicS:
      'Waves and Circulation in the Middle and Upper Atmosphere: Connection across Scales',
    topicL:
      'Waves and Circulation in the Middle and Upper Atmosphere: Connection across Scales',
    id: 'thursday-breakout-1-318',
  },
  'thursday-breakout-1-319': {
    room: '319',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '10:00am-12:00pm',
    name: 'Thursday Breakout 1',
    topicS:
      'New capabilities for studying equatorial aeronomy and space weather',
    topicL:
      'New capabilities for studying equatorial aeronomy and space weather',
    id: 'thursday-breakout-1-319',
  },
  'thursday-lunch-304': {
    room: '304',
    groups: [],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '12:00pm-1:30pm',
    name: 'Thursday Lunch',
    topicS: 'CEDAR - Student feedback lunch',
    topicL: 'CEDAR - Student feedback lunch',
    id: 'thursday-lunch-304',
  },
  'thursday-lunch-boardroom': {
    room: 'boardroom',
    groups: [],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '12:00pm-1:30pm',
    name: 'Thursday Lunch',
    topicS: 'CEDAR - CSS Lunch',
    topicL: 'CEDAR - CSS Lunch',
    id: 'thursday-lunch-boardroom',
  },
  'thursday-lunch-multi': {
    room: 'multi',
    groups: [],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '12:00pm-1:30pm',
    name: 'Thursday Lunch',
    topicS: 'GEM Steering Committee Lunch',
    topicL: 'GEM Steering Committee Lunch',
    id: 'thursday-lunch-multi',
  },
  'thursday-afternoon-joint-plenary-session:-community-care---unravelling-burnout-for-scientists-ball':
    {
      room: 'ball',
      groups: ['burnout'],
      isJoint: false,
      date: 'Thursday, June 26',
      day: 'thursday',
      time: '1:30pm-3:30pm',
      name: 'Thursday Afternoon Joint Plenary Session: Community Care - Unravelling Burnout for Scientists',
      id: 'thursday-afternoon-joint-plenary-session:-community-care---unravelling-burnout-for-scientists-ball',
    },
  'thursday-breakout-2-307': {
    room: '307',
    groups: ['RX'],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '4:00pm-6:00pm',
    name: 'Thursday Breakout 2',
    topicS:
      'How to set up the initial condition for simulations of magnetic reconnection?',
    topicL:
      'How to set up the initial condition for simulations of magnetic reconnection?',
    id: 'thursday-breakout-2-307',
  },
  'thursday-breakout-2-308': {
    room: '308',
    groups: ['SCIMM'],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '4:00pm-6:00pm',
    name: 'Thursday Breakout 2',
    topicS: 'Self-Consistent Inner Magnetospheric Modeling',
    topicL: 'Self-Consistent Inner Magnetospheric Modeling',
    id: 'thursday-breakout-2-308',
  },
  'thursday-breakout-2-309': {
    room: '309',
    groups: ['MPEC', 'CEDAR'],
    isJoint: true,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '4:00pm-6:00pm',
    name: 'Thursday Breakout 2',
    topicS:
      'Drivers, Control, and Effects of the Ionospheric Conductance and Conductivity in the Magnetosphere-Ionosphere-Thermosphere Systems',
    topicL:
      'Drivers, Control, and Effects of the Ionospheric Conductance and Conductivity in the Magnetosphere-Ionosphere-Thermosphere Systems',
    id: 'thursday-breakout-2-309',
  },
  'thursday-breakout-2-318': {
    room: '318',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '4:00pm-6:00pm',
    name: 'Thursday Breakout 2',
    topicS:
      'Expansion of the Neutral Atmosphere and its Impact on M-I-T Coupling',
    topicL:
      'Expansion of the Neutral Atmosphere and its Impact on M-I-T Coupling',
    id: 'thursday-breakout-2-318',
  },
  'thursday-breakout-2-319': {
    room: '319',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '4:00pm-6:00pm',
    name: 'Thursday Breakout 2',
    topicS:
      '(GC) The role of gravity waves in the mesosphere, thermosphere and ionosphere cross-scale coupling and irregularities: Observations and numerical simulations part 1',
    topicL:
      '(GC) The role of gravity waves in the mesosphere, thermosphere and ionosphere cross-scale coupling and irregularities: Observations and numerical simulations part 1',
    id: 'thursday-breakout-2-319',
  },
  'banquet-ball': {
    room: 'ball',
    groups: [],
    isJoint: false,
    date: 'Thursday, June 26',
    day: 'thursday',
    time: '6:30pm-8:30pm',
    name: 'Banquet',
    id: 'banquet-ball',
  },
  'friday-plenary-session-ball': {
    room: 'ball',
    groups: ['plenary'],
    isJoint: false,
    date: 'Friday, June 27',
    day: 'friday',
    time: '8:00am-9:30am',
    name: 'Friday Plenary Session',
    plenId: 'fri',
    id: 'friday-plenary-session-ball',
  },
  'friday-breakout-1-ballA': {
    room: 'ballA',
    groups: ['MESO', 'KiTS', 'CEDAR'],
    isJoint: true,
    date: 'Friday, June 27',
    day: 'friday',
    time: '10:00am-12:00pm',
    name: 'Friday Breakout 1',
    topicS:
      'Magnetotail and Ionosphere Structure and Dynamics Inferred from Low-Altitude and Ground-Based Observations',
    topicL:
      'Magnetotail and Ionosphere Structure and Dynamics Inferred from Low-Altitude and Ground-Based Observations',
    id: 'friday-breakout-1-ballA',
  },
  'friday-breakout-1-ballB': {
    room: 'ballB',
    groups: ['MPEC', 'CEDAR'],
    isJoint: true,
    date: 'Friday, June 27',
    day: 'friday',
    time: '10:00am-12:00pm',
    name: 'Friday Breakout 1',
    topicS: 'Modeling of whole Geospace Coupling and Validation',
    topicL: 'Modeling of whole Geospace Coupling and Validation',
    id: 'friday-breakout-1-ballB',
  },
  'friday-breakout-1-308': {
    room: '308',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Friday, June 27',
    day: 'friday',
    time: '10:00am-12:00pm',
    name: 'Friday Breakout 1',
    topicS:
      'Advances in Meteor, Meteoroid, and Space Debris Science and Engineering',
    topicL:
      'Advances in Meteor, Meteoroid, and Space Debris Science and Engineering',
    id: 'friday-breakout-1-308',
  },
  'friday-breakout-1-309': {
    room: '309',
    groups: ['COMP', 'RBSoS'],
    isJoint: true,
    date: 'Friday, June 27',
    day: 'friday',
    time: '10:00am-12:00pm',
    name: 'Friday Breakout 1',
    topicS: 'Comparative Planetary Radiation Belt Processes',
    topicL: 'Comparative Planetary Radiation Belt Processes',
    id: 'friday-breakout-1-309',
  },
  'friday-breakout-1-318': {
    room: '318',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Friday, June 27',
    day: 'friday',
    time: '10:00am-12:00pm',
    name: 'Friday Breakout 1',
    topicS: 'ISR World Day Planning Meeting',
    topicL: 'ISR World Day Planning Meeting',
    id: 'friday-breakout-1-318',
  },
  'friday-breakout-1-319': {
    room: '319',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Friday, June 27',
    day: 'friday',
    time: '10:00am-12:00pm',
    name: 'Friday Breakout 1',
    topicS:
      'The role of gravity waves in the mesosphere, thermosphere and ionosphere cross-scale coupling and irregularities: Observations and numerical simulations -2',
    topicL:
      'The role of gravity waves in the mesosphere, thermosphere and ionosphere cross-scale coupling and irregularities: Observations and numerical simulations -2',
    id: 'friday-breakout-1-319',
  },
  'friday-lunch-ballA': {
    room: 'ballA',
    groups: [],
    isJoint: false,
    date: 'Friday, June 27',
    day: 'friday',
    time: '12:00pm-1:30pm',
    name: 'Friday Lunch',
    topicS:
      'Townhall: Addressing Advocacy in the Face of Heliophysics Funding Uncertainty',
    topicL:
      'Townhall: Addressing Advocacy in the Face of Heliophysics Funding Uncertainty',
    id: 'friday-lunch-ballA',
  },
  'friday-breakout-2-ballA': {
    room: 'ballA',
    groups: ['MPEC', 'MESO', 'CEDAR'],
    isJoint: true,
    date: 'Friday, June 27',
    day: 'friday',
    time: '1:30pm-3:30pm',
    name: 'Friday Breakout 2',
    topicS:
      'Bridging Models and Observations: Strategies for Quantitative Data-Model Comparisons & Innovative applications of atmosphere-ionosphere models and datasets',
    topicL:
      'Bridging Models and Observations: Strategies for Quantitative Data-Model Comparisons & Innovative applications of atmosphere-ionosphere models and datasets',
    id: 'friday-breakout-2-ballA',
  },
  'friday-breakout-2-ballB': {
    room: 'ballB',
    groups: ['GEM', 'CEDAR'],
    isJoint: true,
    date: 'Friday, June 27',
    day: 'friday',
    time: '1:30pm-3:30pm',
    name: 'Friday Breakout 2',
    topicS:
      'Career Development for Early and Mid-Career Scientists: Strategies for Success',
    topicL:
      'Career Development for Early and Mid-Career Scientists: Strategies for Success',
    id: 'friday-breakout-2-ballB',
  },
  'friday-breakout-2-307': {
    room: '307',
    groups: ['GIC'],
    isJoint: false,
    date: 'Friday, June 27',
    day: 'friday',
    time: '1:30pm-3:30pm',
    name: 'Friday Breakout 2',
    topicS: 'Gannon Storm Session',
    topicL: 'Gannon Storm Session',
    id: 'friday-breakout-2-307',
  },
  'friday-breakout-2-308': {
    room: '308',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Friday, June 27',
    day: 'friday',
    time: '1:30pm-3:30pm',
    name: 'Friday Breakout 2',
    topicS:
      'Ionospheric Scintillation and Plasma Density Irregularities: Impacts on Space Weather',
    topicL:
      'Ionospheric Scintillation and Plasma Density Irregularities: Impacts on Space Weather',
    id: 'friday-breakout-2-308',
  },
  'friday-breakout-2-309': {
    room: '309',
    groups: ['KiTS', 'COMP'],
    isJoint: true,
    date: 'Friday, June 27',
    day: 'friday',
    time: '1:30pm-3:30pm',
    name: 'Friday Breakout 2',
    topicS: 'Thin current sheets throughout the solar system',
    topicL: 'Thin current sheets throughout the solar system',
    id: 'friday-breakout-2-309',
  },
  'friday-breakout-2-318': {
    room: '318',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Friday, June 27',
    day: 'friday',
    time: '1:30pm-3:30pm',
    name: 'Friday Breakout 2',
    topicS:
      'Science Opportunities with the Upcoming NASA Carruthers Geocorona Observatory Mission',
    topicL:
      'Science Opportunities with the Upcoming NASA Carruthers Geocorona Observatory Mission',
    id: 'friday-breakout-2-318',
  },
  'friday-breakout-2-319': {
    room: '319',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Friday, June 27',
    day: 'friday',
    time: '1:30pm-3:30pm',
    name: 'Friday Breakout 2',
    topicS:
      '(GC) Impact of Terrestrial Weather on the Space Weather of the Ionosphere-Thermosphere-Mesosphere part 1',
    topicL:
      '(GC) Impact of Terrestrial Weather on the Space Weather of the Ionosphere-Thermosphere-Mesosphere part 1',
    id: 'friday-breakout-2-319',
  },
  'friday-breakout-3-ballA': {
    room: 'ballA',
    groups: ['MESO', 'CEDAR'],
    isJoint: true,
    date: 'Friday, June 27',
    day: 'friday',
    time: '4:00pm-6:00pm',
    name: 'Friday Breakout 3',
    topicS: 'Electrodynamic coupling',
    topicL:
      'Electrodynamic Coupling of the Thermosphere, Ionosphere and Magnetosphere from High to Low Latitudes',
    id: 'friday-breakout-3-ballA',
  },
  'friday-breakout-3-ballB': {
    room: 'ballB',
    groups: ['MPEC', 'CEDAR'],
    isJoint: true,
    date: 'Friday, June 27',
    day: 'friday',
    time: '4:00pm-6:00pm',
    name: 'Friday Breakout 3',
    topicS: 'Auroral Science',
    topicL:
      'Advancements in auroral science for magnetosphere-ionosphere-thermosphere-atmosphere coupling with multi-point measurements',
    id: 'friday-breakout-3-ballB',
  },
  'friday-breakout-3-318': {
    room: '318',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Friday, June 27',
    day: 'friday',
    time: '4:00pm-6:00pm',
    name: 'Friday Breakout 3',
    topicS: 'Neutral winds',
    topicL:
      'Advancing Neutral Wind Measurements: New Instrumentation and Recent Discoveries',
    id: 'friday-breakout-3-318',
  },
  'friday-breakout-3-319': {
    room: '319',
    groups: ['CEDAR'],
    isJoint: false,
    date: 'Friday, June 27',
    day: 'friday',
    time: '4:00pm-6:00pm',
    name: 'Friday Breakout 3',
    topicS: 'Weather-2 (GC)',
    topicL:
      '(GC) Impact of Terrestrial Weather on the Space Weather of the Ionosphere-Thermosphere-Mesosphere part 2',
    id: 'friday-breakout-3-319',
  },
}
export const daySessions = {
  student: [['student-session-ball'], ['welcome-reception-hotel']],
  monday: [
    ['monday-plenary-session-1-ball'],
    ['monday-plenary-session-2-ball'],
    ['monday-lunch-ballJr'],
    [
      'monday-breakout-1-ballA',
      'monday-breakout-1-ballB',
      'monday-breakout-1-307',
      'monday-breakout-1-308',
      'monday-breakout-1-309',
      'monday-breakout-1-318',
      'monday-breakout-1-319',
    ],
    [
      'monday-breakout-2-ballA',
      'monday-breakout-2-ballB',
      'monday-breakout-2-307',
      'monday-breakout-2-308',
      'monday-breakout-2-309',
      'monday-breakout-2-318',
      'monday-breakout-2-319',
    ],
    ['monday-dinner-ballJr', 'monday-dinner-boardroom'],
  ],
  tuesday: [
    ['tuesday-plenary-sessions-ballB', 'tuesday-plenary-sessions-ballA'],
    [
      'tuesday-breakout-1-ballA',
      'tuesday-breakout-1-ballB',
      'tuesday-breakout-1-307',
      'tuesday-breakout-1-308',
      'tuesday-breakout-1-309',
      'tuesday-breakout-1-318',
      'tuesday-breakout-1-319',
    ],
    ['tuesday-lunch-304', 'tuesday-lunch-boardroom'],
    [
      'tuesday-breakout-2-ballA',
      'tuesday-breakout-2-ballB',
      'tuesday-breakout-2-308',
      'tuesday-breakout-2-309',
      'tuesday-breakout-2-318',
      'tuesday-breakout-2-319',
    ],
    ['tuesday-poster-session-posters'],
    ['evening-activities-boardroom', 'evening-activities-away'],
  ],
  wednesday: [
    ['wednesday-plenary-session-ball'],
    [
      'wednesday-breakout-1-ballA',
      'wednesday-breakout-1-ballB',
      'wednesday-breakout-1-307',
      'wednesday-breakout-1-308',
      'wednesday-breakout-1-309',
      'wednesday-breakout-1-318',
      'wednesday-breakout-1-319',
    ],
    ['wednesday-lunch-ballA', 'wednesday-lunch-boardroom'],
    [
      'wednesday-breakout-2-ballA',
      'wednesday-breakout-2-ballB',
      'wednesday-breakout-2-307',
      'wednesday-breakout-2-308',
      'wednesday-breakout-2-309',
      'wednesday-breakout-2-318',
      'wednesday-breakout-2-319',
    ],
    ['wednesday-poster-session-posters'],
    ['wednesday-dinner-boardroom'],
  ],
  thursday: [
    ['thursday-plenary-sessions-ballB', 'thursday-plenary-sessions-ballA'],
    ['community-care---compassionate-leadership-for-burnout-305'],
    [
      'thursday-breakout-1-ballA',
      'thursday-breakout-1-ballB',
      'thursday-breakout-1-307',
      'thursday-breakout-1-308',
      'thursday-breakout-1-309',
      'thursday-breakout-1-318',
      'thursday-breakout-1-319',
    ],
    ['thursday-lunch-304', 'thursday-lunch-boardroom', 'thursday-lunch-multi'],
    [
      'thursday-afternoon-joint-plenary-session:-community-care---unravelling-burnout-for-scientists-ball',
    ],
    [
      'thursday-breakout-2-307',
      'thursday-breakout-2-308',
      'thursday-breakout-2-309',
      'thursday-breakout-2-318',
      'thursday-breakout-2-319',
    ],
    ['banquet-ball'],
  ],
  friday: [
    ['friday-plenary-session-ball'],
    [
      'friday-breakout-1-ballA',
      'friday-breakout-1-ballB',
      'friday-breakout-1-308',
      'friday-breakout-1-309',
      'friday-breakout-1-318',
      'friday-breakout-1-319',
    ],
    ['friday-lunch-ballA'],
    [
      'friday-breakout-2-ballA',
      'friday-breakout-2-ballB',
      'friday-breakout-2-307',
      'friday-breakout-2-308',
      'friday-breakout-2-309',
      'friday-breakout-2-318',
      'friday-breakout-2-319',
    ],
    [
      'friday-breakout-3-ballA',
      'friday-breakout-3-ballB',
      'friday-breakout-3-318',
      'friday-breakout-3-319',
    ],
  ],
}
export const groupSessions = {
  student: ['student-session-ball'],
  plenary: [
    'monday-plenary-session-1-ball',
    'monday-plenary-session-2-ball',
    'tuesday-plenary-sessions-ballB',
    'tuesday-plenary-sessions-ballA',
    'wednesday-plenary-session-ball',
    'thursday-plenary-sessions-ballB',
    'thursday-plenary-sessions-ballA',
    'friday-plenary-session-ball',
  ],
  KiTS: [
    'monday-breakout-1-ballA',
    'monday-breakout-2-ballA',
    'friday-breakout-1-ballA',
    'friday-breakout-2-309',
  ],
  RX: [
    'monday-breakout-1-ballA',
    'monday-breakout-2-ballA',
    'tuesday-breakout-1-309',
    'wednesday-breakout-2-307',
    'thursday-breakout-1-307',
    'thursday-breakout-2-307',
  ],
  MESO: [
    'monday-breakout-1-ballA',
    'monday-breakout-2-ballA',
    'tuesday-breakout-1-ballA',
    'tuesday-breakout-2-ballA',
    'wednesday-breakout-1-ballA',
    'wednesday-breakout-2-ballA',
    'thursday-breakout-1-ballA',
    'friday-breakout-1-ballA',
    'friday-breakout-2-ballA',
    'friday-breakout-3-ballA',
  ],
  CEDAR: [
    'monday-breakout-1-ballA',
    'monday-breakout-1-ballB',
    'monday-breakout-1-318',
    'monday-breakout-1-319',
    'monday-breakout-2-ballA',
    'monday-breakout-2-ballB',
    'monday-breakout-2-318',
    'monday-breakout-2-319',
    'tuesday-breakout-1-ballA',
    'tuesday-breakout-1-ballB',
    'tuesday-breakout-1-318',
    'tuesday-breakout-1-319',
    'tuesday-breakout-2-ballA',
    'tuesday-breakout-2-ballB',
    'tuesday-breakout-2-318',
    'tuesday-breakout-2-319',
    'wednesday-breakout-1-ballA',
    'wednesday-breakout-1-ballB',
    'wednesday-breakout-1-309',
    'wednesday-breakout-1-318',
    'wednesday-breakout-1-319',
    'wednesday-breakout-2-ballA',
    'wednesday-breakout-2-ballB',
    'wednesday-breakout-2-309',
    'wednesday-breakout-2-318',
    'wednesday-breakout-2-319',
    'thursday-breakout-1-ballA',
    'thursday-breakout-1-ballB',
    'thursday-breakout-1-318',
    'thursday-breakout-1-319',
    'thursday-breakout-2-309',
    'thursday-breakout-2-318',
    'thursday-breakout-2-319',
    'friday-breakout-1-ballA',
    'friday-breakout-1-ballB',
    'friday-breakout-1-308',
    'friday-breakout-1-318',
    'friday-breakout-1-319',
    'friday-breakout-2-ballA',
    'friday-breakout-2-ballB',
    'friday-breakout-2-308',
    'friday-breakout-2-318',
    'friday-breakout-2-319',
    'friday-breakout-3-ballA',
    'friday-breakout-3-ballB',
    'friday-breakout-3-318',
    'friday-breakout-3-319',
  ],
  COMP: [
    'monday-breakout-1-ballB',
    'tuesday-breakout-2-308',
    'friday-breakout-1-309',
    'friday-breakout-2-309',
  ],
  MPEC: [
    'monday-breakout-1-307',
    'monday-breakout-2-307',
    'tuesday-breakout-1-ballA',
    'tuesday-breakout-2-ballB',
    'wednesday-breakout-1-ballB',
    'wednesday-breakout-2-ballB',
    'thursday-breakout-1-ballB',
    'thursday-breakout-2-309',
    'friday-breakout-1-ballB',
    'friday-breakout-2-ballA',
    'friday-breakout-3-ballB',
  ],
  CP: [
    'monday-breakout-1-308',
    'monday-breakout-2-308',
    'tuesday-breakout-1-308',
    'tuesday-breakout-2-309',
  ],
  MDT: [
    'monday-breakout-1-309',
    'monday-breakout-2-309',
    'tuesday-breakout-1-309',
  ],
  MMV: ['monday-breakout-2-ballB', 'thursday-breakout-1-ballA'],
  RBSoS: [
    'tuesday-breakout-1-ballB',
    'tuesday-breakout-2-309',
    'wednesday-breakout-1-308',
    'wednesday-breakout-2-308',
    'thursday-breakout-1-308',
    'friday-breakout-1-309',
  ],
  GIC: [
    'tuesday-breakout-1-307',
    'wednesday-breakout-1-307',
    'thursday-breakout-1-309',
    'friday-breakout-2-307',
  ],
  MLGEM: ['wednesday-breakout-1-309', 'wednesday-breakout-2-309'],
  burnout: [
    'community-care---compassionate-leadership-for-burnout-305',
    'thursday-afternoon-joint-plenary-session:-community-care---unravelling-burnout-for-scientists-ball',
  ],
  SCIMM: ['thursday-breakout-1-ballA', 'thursday-breakout-2-308'],
  GMAG: ['thursday-breakout-1-309'],
  GEM: ['friday-breakout-2-ballB'],
}
